import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Header = ({ activeTab, setActiveTab, scrollToTop }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogoClick = () => {
    scrollToTop();
  };

  // Unified navigation - same structure for both tabs to prevent layout shift
  const navItems = [
    { 
      label: 'Home', 
      href: '#home'
    },
    { 
      label: activeTab === 'industries' ? 'Services' : 'SR&ED Basics', 
      href: activeTab === 'industries' ? '#services' : '#sred-basics'
    },
    { 
      label: activeTab === 'industries' ? 'Process' : 'Calculator', 
      href: activeTab === 'industries' ? '#process' : '#calculator'
    },
    { 
      label: activeTab === 'industries' ? 'About' : 'Industries', 
      href: activeTab === 'industries' ? '#about' : '#industries'
    },
    { 
      label: 'Contact', 
      href: '#contact'
    }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer" 
            onClick={handleLogoClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleLogoClick()}
          >
            <div className="bg-white p-2 rounded">
              <img 
                src={companyInfo.logo} 
                alt={companyInfo.name}
                className="h-12 w-auto object-contain"
              />
            </div>
          </div>

          {/* Tab Switcher */}
          <div className="hidden md:flex items-center bg-white/5 rounded-none p-1">
            <button
              onClick={() => setActiveTab('industries')}
              className={`px-4 py-2 text-sm font-medium transition-all duration-300 ${
                activeTab === 'industries'
                  ? 'bg-[#4A90A4] text-white'
                  : 'text-white/60 hover:text-white'
              }`}
            >
              Philcan Industries
            </button>
            <button
              onClick={() => setActiveTab('innovation')}
              className={`px-4 py-2 text-sm font-medium transition-all duration-300 ${
                activeTab === 'innovation'
                  ? 'bg-[#4A90A4] text-white'
                  : 'text-white/60 hover:text-white'
              }`}
            >
              Philcan Innovation
            </button>
          </div>

          {/* Desktop Navigation - Fixed width items to prevent shift */}
          <nav className="hidden lg:flex items-center gap-6">
            {navItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className="text-white/60 hover:text-[#4A90A4] text-sm font-medium transition-colors duration-300 min-w-[90px] text-center"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              className="bg-[#4A90A4] text-white px-6 py-3 text-sm font-medium hover:bg-[#5BA0B4] transition-all duration-300"
            >
              Book a Consultation
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden pb-6">
            {/* Mobile Tab Switcher */}
            <div className="flex mb-4 bg-white/5 p-1">
              <button
                onClick={() => {
                  setActiveTab('industries');
                  setMobileMenuOpen(false);
                }}
                className={`flex-1 px-4 py-2 text-sm font-medium transition-all duration-300 ${
                  activeTab === 'industries'
                    ? 'bg-[#4A90A4] text-white'
                    : 'text-white/60'
                }`}
              >
                Industries
              </button>
              <button
                onClick={() => {
                  setActiveTab('innovation');
                  setMobileMenuOpen(false);
                }}
                className={`flex-1 px-4 py-2 text-sm font-medium transition-all duration-300 ${
                  activeTab === 'innovation'
                    ? 'bg-[#4A90A4] text-white'
                    : 'text-white/60'
                }`}
              >
                Innovation
              </button>
            </div>
            <nav className="flex flex-col gap-4">
              {navItems.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  className="text-white/60 hover:text-[#4A90A4] text-sm font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#contact"
                className="bg-[#4A90A4] text-white px-6 py-3 text-sm font-medium text-center hover:bg-[#5BA0B4] transition-all duration-300 mt-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Book a Consultation
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
